import { SyntheticEvent } from 'react';

export default function getImageURL(icon: string) {
    return `${process.env.PUBLIC_URL}/images/${icon}.png`;
}

export function getImageURLRemoveSpaces(icon: string) {
    return `${process.env.PUBLIC_URL}/images/${icon.replace(/\s/g, '')}.png`;
}

// used when a food icon has not been added to the images folder yet
export function handleImageError(event: SyntheticEvent<HTMLImageElement>) {
    const image = event.currentTarget;
    const fallback = getImageURL('UnknownFood');
    if (!image.src.endsWith(fallback)) {
        image.src = fallback;
    }
}
